import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "@/data/siteData";

export default function ServicesPage() {
  const flooringServices = SERVICES.filter(s => s.category === "flooring");
  const handymanServices = SERVICES.filter(s => s.category === "handyman");

  const renderServiceRow = (service, i) => (
    <div
      key={service.id}
      data-testid={`service-detail-${service.id}`}
      className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
    >
      <div className={`${i % 2 !== 0 ? "lg:order-2" : ""}`}>
        <div className="relative overflow-hidden group">
          <img
            src={service.image}
            alt={service.title}
            className="w-full h-72 lg:h-96 object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 border border-[#D4AF37]/20" />
        </div>
      </div>
      <div className={`${i % 2 !== 0 ? "lg:order-1" : ""}`}>
        <p className="font-sans uppercase text-xs tracking-[0.2em] text-[#D4AF37] mb-3">
          {String(i + 1).padStart(2, "0")}
        </p>
        <h3 className="font-serif text-3xl sm:text-4xl text-white mb-4">{service.title}</h3>
        <p className="font-sans text-base text-[#A3A3A3] leading-relaxed mb-6">
          {service.description}
        </p>
        <ul className="grid grid-cols-2 gap-3 mb-8">
          {service.features?.map((feat, fi) => (
            <li key={fi} className="flex items-center gap-2 text-sm text-white/80 font-sans">
              <span className="gold-dot flex-shrink-0" />
              {feat}
            </li>
          ))}
        </ul>
        <Link
          to="/contact"
          data-testid={`service-quote-${service.id}`}
          className="inline-flex items-center gap-2 bg-[#D4AF37] text-black font-semibold px-8 py-3 text-sm uppercase tracking-wider hover:bg-[#F0C74A] transition-colors"
        >
          Get a Quote
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );

  return (
    <main data-testid="services-page" className="pt-20">
      {/* Header */}
      <section className="py-20 md:py-28 bg-[#0a0a0a] border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <p className="font-sans uppercase text-xs tracking-[0.2em] text-[#D4AF37] mb-4">Our Expertise</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white mb-4">
            Our Services
          </h1>
          <p className="font-sans text-base text-[#A3A3A3] max-w-2xl mx-auto">
            From premium flooring to complete handyman solutions — one team for every job around your property.
          </p>
        </div>
      </section>

      {/* Flooring Services */}
      <section className="py-16 md:py-24 bg-[#050505]" data-testid="flooring-category">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center gap-4 mb-12">
            <div className="gold-line flex-1" />
            <h2 className="font-serif text-2xl sm:text-3xl text-white whitespace-nowrap">Flooring Services</h2>
            <div className="gold-line flex-1" />
          </div>
          <div className="grid grid-cols-1 gap-16">
            {flooringServices.map((service, i) => renderServiceRow(service, i))}
          </div>
        </div>
      </section>

      {/* Handyman Services */}
      <section className="py-16 md:py-24 bg-[#0a0a0a]" data-testid="handyman-category">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center gap-4 mb-12">
            <div className="gold-line flex-1" />
            <h2 className="font-serif text-2xl sm:text-3xl text-white whitespace-nowrap">Handyman Services</h2>
            <div className="gold-line flex-1" />
          </div>
          <div className="grid grid-cols-1 gap-16">
            {handymanServices.map((service, i) => renderServiceRow(service, i))}
          </div>
        </div>
      </section>
    </main>
  );
}
